import { Routes } from "@angular/router";
import { DirtyGuard } from "~app/common/guards/dirty.guard";
import { RaskRoller } from "~app/common/models/constants";
import { HanteraLagermalComponent } from "~app/features/hantera-lagermal/components/hantera-lagermal/hantera-lagermal.component";
import { ExternArbetsorderSearchComponent } from "~app/features/Leverans/extern-arbetsorder/extern-arbetsorder-search/extern-arbetsorder-search.component";
import { ExternArbetsorderComponent } from "~app/features/Leverans/extern-arbetsorder/extern-arbetsorder.component";
import { ProduktionsmallarComponent } from "~app/features/planera/produktionsmallar/produktionsmallar.component";

export const leveransRoutes: Routes = [
    {
        path: "lagermal",
        title: "Lagermål",
        component: HanteraLagermalComponent,
        canDeactivate: [DirtyGuard],
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Produktionsleda]
        }
    },
    {
        path: "ckproduktionsmall",
        title: "Produktionsmallar",
        component: ProduktionsmallarComponent,
        canDeactivate: [DirtyGuard],
        data: {
            requiredRoles: RaskRoller.role.Titta,
            editRoles: RaskRoller.role.Kundhantera,
            isCKMall: true
        }
    },
    {
        path: "externarbetsorder",
        title: "Sök extern arbetsorder",
        children: [
            {
                path: "",
                component: ExternArbetsorderSearchComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Kundhantera]
                }
            },
            {
                path: ":id",
                title: "Extern arbetsorder detaljer",
                canDeactivate: [DirtyGuard],
                component: ExternArbetsorderComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Kundhantera]
                }
            }
        ]
    }
];
